
export default function MapSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-emerald-700 font-bold text-xs tracking-widest uppercase mb-3">
            Service Area
          </span>
          <h2 className="text-3xl font-bold tracking-wide">Serving the Mid-Atlantic Region</h2>
          <p className="text-gray-600 mt-3 max-w-xl mx-auto">
            We operate across Pennsylvania, Maryland, Delaware, Virginia, and West Virginia. If you&apos;re in the region, we can help.
          </p>
        </div>

        <div className="w-full h-[400px] rounded-lg overflow-hidden shadow-sm border border-gray-200">
          {/* Using a self‑closing iframe to avoid JSX parsing issues */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3200000!2d-77.5!3d39.5!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Greenfield Partners Service Area - Mid-Atlantic Region"
          />
        </div>

        <div className="mt-6 grid sm:grid-cols-5 gap-4 text-center">
          {['Pennsylvania', 'Maryland', 'Delaware', 'Virginia', 'West Virginia'].map((state) => (
            <div key={state} className="flex items-center justify-center gap-2 text-sm text-gray-700">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-check-line text-emerald-600"></i>
              </div>
              <span className="font-medium">{state}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
